export const BYNDER_UPLOAD_TYPES = {
    MULTIPLE: 'multiple',
    SINGLE: 'single'
};

export const BYNDER_IMAGE_TYPES = {
    JPEG: 'jpeg',
    PNG: 'png',
    PSD: 'psd'
};

export const BYNDER_PUBLISH_SETTINGS = 'bynder_publish_settings';

export const BYNDER_META_VALUES = 'bynder_meta_values';

// multi selects
export const PEPSI_GTIN = 'GTIN';
export const PEPSI_GVN = 'Graphic_Version_Number';
export const PEPSI_BRAND = 'Brand';
export const PEPSI_SUB_BRAND = 'SubBrand';
export const PEPSI_TARGET_MARKET = 'Country';
export const PEPSI_ASSET_FORMAT = 'Asset_Format';
export const PEPSI_SECTOR = 'Sector';

export const PEPSI_SECTOR_MAP = {
    'Food': 'PFNA',
    'Beverage': 'PBNA',
};

//dates
export const PEPSI_IN_MARKET_DATE = 'InMarketDate';
export const PEPSI_EXPIRY_DATE = 'ExpiryDate';

export const RAPID_IN_MARKET_DATE = 'In_Market_Date';
export const RAPID_EXPIRY_DATE = 'Expiry_Date';

// selects
export const PEPSI_IMAGE_NATURE = 'Image_Nature';
export const PEPSI_FACING_INDICATOR = 'Facing_Indicator';
export const PEPSI_ANGLE_IDENTIFIER = 'Angle_Identifier';
export const PEPSI_IO_PACKAGING = 'IO_Packaging';
export const PEPSI_SEQUENCE_NUMBER = 'Sequence_Number';
export const PEPSI_LANGUAGE = 'Language';
export const PEPSI_TARGET_CUSTOMER = 'Target_Customer';

export const DEFAULT_EXPIRY_DATE = '2099-12-31';

export const PLATFORM_KEY_TESTING = '_testing';
export const PLATFORM_KEY_PRODUCTION = '_production';

export const LANGUAGE_MAP = {
    'en': 'English',
    'fr': 'French',
    'fr-ca': 'French Canadian',
    'de': 'German',
    'es': 'Spanish',
    'it': 'Italian',
    'ar': 'Arabic',
    'hy': 'Armenian',
    'az': 'Azerbaijani',
    'ca': 'Catalan',
    'zh': 'Chinese',
    'nl': 'Dutch',
    'fil': 'Filipino',
    'nl-be': 'Flemish',
    'fi': 'Finnish',
    'ka': 'Georgian',
    'el': 'Greek',
    'hi': 'Hindi',
    'ms': 'Malay',
    'pl': 'Polish',
    'pt': 'Portuguese',
    'ro': 'Romanian',
    'ru': 'Russian',
    'sr': 'Serbian',
    'sv': 'Swedish',
    'th': 'Thai',
    'tr': 'Turkish',
    'uk': 'Ukrainian',
    'vi': 'Vietnamese',
    'md': 'Marketing/Design'
};
